import { useState } from 'react';
import {
	Datepicker,
	NumberField,
	InfoChip,
	MediumDialog,
	Spacer,
} from '@components';
import { CHIP_TYPE, PartialInputEvent } from '@types';
import { ChangeEvent } from 'react';
import { formatDate } from '@utils';
import styles from './FuelLevySettingsPanel.module.scss';


type TScheduleFuelLevyModalProps = {
	settingsInRoute: boolean,
	editingFuelLevyType: 'next' | 'current',
	startAt: string,
	tariff: string,
	newTypeLabel: string,
	onConfirmFuelLevyUpdate: (value: {
		startAt: string,
		tariff: string
	}) => void;
	onCloseDialog: () => void;
	isFirstSchedule: boolean;
}

export const ScheduleFuelLevyModal = (props: TScheduleFuelLevyModalProps) => {
	const {
		settingsInRoute,
		editingFuelLevyType,
		startAt,
		tariff,
		newTypeLabel,
		onConfirmFuelLevyUpdate,
		onCloseDialog,
		isFirstSchedule
	} = props;

	const [fuelLevyValue, setFuelLevyValue] = useState({
		startAt: isFirstSchedule ? formatDate(new Date()) : startAt,
		tariff
	});

	const handleInputUpdate = (e: ChangeEvent<HTMLInputElement> | PartialInputEvent) => {
		const { name, value } = e.target;
		setFuelLevyValue((prev) => {
			return {
				...prev,
				[name]: typeof value !== 'string' ? formatDate(value as Date, 'SHORT_DATE') : value
			}
		});
	}

	return 	<MediumDialog
		title='Schedule fuel levy'
		text={''}
		slot={<div>
			{
				settingsInRoute &&
							<>
								<InfoChip type={CHIP_TYPE.WARN} text={`Applies to all rate cards using the ${newTypeLabel} fuel levy`} />
								<Spacer size={20} />
							</>
			}

			{
				editingFuelLevyType && <>
					<Datepicker
						label={'Starting date'}
						name={'startAt'}
						value={fuelLevyValue.startAt}
						onChange={(e) => handleInputUpdate(e as PartialInputEvent)}
						disableFuture={editingFuelLevyType === 'current'}
						disablePast={true}
						keepErrorSpace={false}
						disabled={isFirstSchedule}
					/>
					<Spacer size={20} />
					<NumberField
						label={'Fuel levy'}
						name={'tariff'}
						value={fuelLevyValue.tariff}
						onChange={handleInputUpdate}
						keepErrorSpace={false}
						placeholder='Enter a fuel levy'
						rightModule={<span className={styles.suffix}>%</span>}
					/>
				</>
			}
		</div>
		}
		open={!!editingFuelLevyType}
		onClose={() => onCloseDialog()}
		actionButtonFn={() => onConfirmFuelLevyUpdate(fuelLevyValue)}
		actionButtonDisabled={!fuelLevyValue.startAt || !fuelLevyValue.tariff}
		actionButtonText={'Confirm'}
	/>
}

